<template>
  <v-container fluid
               class="tfb-container">
    <h1 class="tfb-title-text-medium text-darker-blue text-uppercase">
      Premium Finance Payments
    </h1>
    <v-row>
      <v-col cols="12">
        <v-container fluid
                     class="drop-shadow tfb-smaller-container background-white tfb-bottom-form-margin">
          <div v-if="!showForm && !showReview && !showFinal">
            <v-row>
              <v-col cols="12">
                <h2 class="tfb-title-text-small text-darker-blue text-uppercase">
                  Terms &amp; Conditions
                </h2>
              </v-col>
            </v-row>
            <premium-finance-terms-conditions></premium-finance-terms-conditions>
            <ValidationObserver ref="obv"
                                v-slot="{ handleSubmit }">
              <v-form ref="verifyForm"
                      @submit.stop.prevent="handleSubmit(acceptTerms)">
                <v-row>
                  <v-col cols="12">
                    <text-input :rules="memberRules"
                                label="Member Number"
                                autocapitalize="characters"
                                minlength="4"
                                maxlength="11"
                                v-model="verifyForm.memberNumber"></text-input>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <v-btn block
                           @click="cancelPayment()"
                           class="tfb-button background-red">Cancel</v-btn>
                  </v-col>
                  <v-col cols="6">
                    <v-btn block
                           :disabled="formDisabled"
                           type="submit"
                           class="tfb-button background-red">Submit</v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </ValidationObserver>
          </div>
          <div v-if="showForm">
            <v-row>
              <v-col cols="12">
                <h2 class="tfb-title-text-small text-darker-blue text-uppercase">
                  Make a Payment
                </h2>
              </v-col>
            </v-row>
            <!-- Display pre-filled form -->
            <ValidationObserver ref="obvpay" v-slot="{ handleSubmit }">
              <v-form ref="paymentForm"
                      @submit.stop.prevent="handleSubmit(authPayment)">
                <v-row>
                  <v-col cols="12">
                    <text-input rules="required|routing_number|confirmed:routing|min:4|max:17"
                                minlength="4"
                                maxlength="17"
                                label="Bank Routing Number"
                                v-model="paymentForm.routingNumber"
                                @blur="getBankName()"></text-input>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <text-input rules="required|min:4|max:17"
                                minlength="4"
                                maxlength="17"
                                label="Confirm Bank Routing Number"
                                v-model="paymentForm.confirmRoutingNumber"
                                vid="routing"></text-input>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <text-input rules="required"
                                label="Bank Name"
                                disabled
                                v-model="bankName"></text-input>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <text-input rules="required|confirmed:account|min:4|max:17"
                                minlength="4"
                                maxlength="17"
                                label="Bank Account Number"
                                v-model="paymentForm.accountNumber"></text-input>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <text-input rules="required|min:4|max:17"
                                minlength="4"
                                maxlength="17"
                                label="Confirm Bank Account Number"
                                v-model="paymentForm.confirmAccountNumber"
                                vid="account"></text-input>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <select-input rules="required"
                                  label="Payment Type"
                                  :items="paymentTypeOptions"
                                  item-text="DisplayText"
                                  item-value="Value"
                                  v-model="paymentType"
                                  @change="paymentTypeChange()"></select-input>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <text-input rules="required|min:1|max:10|decimal"
                                label="Payment Amount"
                                type="number"
                                prefix="mdi-currency-usd"
                                :disabled="amountDisabled"
                                v-model="paymentForm.paymentAmount"></text-input>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <v-btn block
                           @click="cancelPayment()"
                           class="tfb-button background-red">Cancel</v-btn>
                  </v-col>
                  <v-col cols="6">
                    <v-btn block
                           :disabled="formDisabled"
                           type="submit"
                           class="tfb-button background-red">Submit</v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </ValidationObserver>
          </div>
          <div v-if="showReview">
            <v-row>
              <v-col cols="12">
                <h2 class="tfb-title-text-small text-darker-blue text-uppercase">
                  Authorization
                </h2>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <span class="tfb-title-text-smaller">Please review the entered transaction information.
                  <span class="tfb-title-text-smaller font-weight-bold">Your payment is not complete until you click the &ldquo;Approve&rdquo; button below.</span>
                </span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <label class="font-weight-bold">Payment Date:</label> {{formatDate(paymentDate)}}<br />
                <label class="font-weight-bold">Contract Number:</label> {{contractNumber}}<br />
                <label class="font-weight-bold">Payment Amount:</label> {{formatMoney(paymentForm.paymentAmount, 2)}}<br />
                <label class="font-weight-bold">Routing Number:</label> {{paymentForm.routingNumber}}<br />
                <label class="font-weight-bold">Account Number:</label> {{paymentForm.accountNumber}}<br />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                By clicking &ldquo;Approve&rdquo;, I understand the payment cannot be revoked and that the listed amount
                will be drafted from the listed account as a one-time transaction.
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-btn block
                       @click="cancelPayment()"
                       class="tfb-button background-red">Cancel</v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn block
                       @click="makePayment()"
                       class="tfb-button background-red">Approve</v-btn>
              </v-col>
            </v-row>
          </div>
          <div v-if="showFinal">
            <v-row>
              <v-col cols="12">
                <h2 class="tfb-title-text-small text-darker-blue text-uppercase">
                  Confirmation
                </h2>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <span class="tfb-title-text-small">Your payment has been received.</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <span class="tfb-title-text-smaller">
                  Your confirmation number is <span class="text-red font-weight-bold">{{confirmationNumber}}</span>
                </span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <label class="font-weight-bold">Payment Date:</label> {{formatDate(paymentDate)}}<br />
                <label class="font-weight-bold">Contract Number:</label> {{contractNumber}}<br />
                <label class="font-weight-bold">Confirmation Number:</label> {{confirmationNumber}}<br />
                <label class="font-weight-bold">Payment Amount:</label> {{formatMoney(paymentForm.paymentAmount, 2)}}<br />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-btn block
                       @click="printConfirmation()"
                       class="tfb-button background-red">Print</v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn block
                       @click="cancelPayment()"
                       class="tfb-button background-red">Return to Account Summary</v-btn>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  /* eslint prefer-destructuring: 0 */
  /* eslint object-shorthand: 0 */
  import { dispatch } from 'vuex-pathify';
  import { ValidationObserver } from 'vee-validate';
  import tfbMetaInfo from '@/mixins/metaInfo';
  import tfbHelperMixin from '@/mixins/helpers';
  import PremiumFinanceTermsConditions from './premiumfinance/TermsConditions.vue';

  export default {
    name: 'NonLoggedInPremiumFinancePayments',
    mixins: [tfbMetaInfo, tfbHelperMixin],
    components: {
      ValidationObserver,
      PremiumFinanceTermsConditions,
    },
    data() {
      return {
        formDisabled: false,
        bankName: null,
        showForm: false,
        showReview: false,
        showFinal: false,
        paymentType: 'C',
        amountDisabled: true,
        contractNumber: null,
        memberNumber: null,
        currentPaymentAmount: null,
        paymentForm: {
          routingNumber: null,
          confirmRoutingNumber: null,
          accountNumber: null,
          confirmAccountNumber: null,
          paymentAmount: null,
        },
        verifyForm: {
          memberNumber: null,
        },
        memberRules: {
          required: true,
          min: 4,
          max: 11,
          is: '',
        },
        confirmationNumber: null,
        paymentDate: null,
        paymentTypeOptions: [{ Value: 'C', DisplayText: 'Current Payment' }, { Value: 'O', DisplayText: 'Other Payment' }],
      };
    },
    computed: {
      metaPageTitle() {
        return 'Premium Finance Payments | PolicyHolder';
      },
      metaUrl() {
        return `${process.env.VUE_APP_ROOT_URI}/payments/premium-finance`;
      },
      queryPremiumFinance() {
        if (this.$route.query.contract && this.$route.query.contract !== undefined && this.$route.query.contract !== null) {
          return this.$route.query.contract;
        }

        return null;
      },
    },
    methods: {
      getBankName() {
        dispatch('app/clearErrorMessage');
        dispatch('payments/gwValidateRoutingNumber', {
          sRoutingNumber: this.paymentForm.routingNumber, sTfbId: this.trackingId,
        })
          .then((validationResult) => {
            this.bankName = validationResult;
            if (!validationResult || validationResult === '') {
              this.paymentForm.routingNumber = null;
            }
          })
          .catch((error) => {
            dispatch('app/setErrorMessage', error.toString());
          });
      },
      paymentTypeChange() {
        if (this.paymentType === 'O' || (this.paymentType === 'C' && this.currentPaymentAmount === null)) {
          this.paymentForm.paymentAmount = '0.00';
          this.amountDisabled = false;
        } else {
          this.paymentForm.paymentAmount = this.currentPaymentAmount;
          this.amountDisabled = true;
        }
      },
      cancelPayment() {
        // Go back to Summary screen
        this.$router.push({ name: 'policyholderAccountSummary' });
      },
      acceptTerms() {
        // Accepted the terms, so show the payment form
        this.showForm = true;
      },
      authPayment() {
        dispatch('app/clearErrorMessage');
        this.paymentDate = new Date().toISOString();
        this.showFinal = false;
        this.showReview = true;
        this.showForm = false;
      },
      makePayment() {
        dispatch('app/clearErrorMessage');
        dispatch('app/setIsLoading', true);
        this.$store.dispatch('app/logToULS', {
          logLevel: 'Info',
          logMessage: `${this.contractNumber}-${this.memberNumber}-${this.paymentForm.paymentAmount}`,
          fileName: 'NonLoggedInPremiumFinancePayment.vue',
          methodName: 'makePayment-Start',
          trackerId: this.trackingId,
        });
        dispatch('payments/makePremiumFinancePayment', {
          sAccountNumber: this.paymentForm.accountNumber,
          sContractNumber: this.contractNumber,
          sMemberNumber: this.memberNumber,
          sPaymentAmount: this.paymentForm.paymentAmount,
          sRoutingNumber: this.paymentForm.routingNumber,
          sTfbId: this.trackingId,
        })
          .then((paymentResult) => {
            this.$store.dispatch('app/logToULS', {
              logLevel: 'Info',
              logMessage: paymentResult,
              fileName: 'NonLoggedInPremiumFinancePayment.vue',
              methodName: 'makePremiumFinancePayment-Response',
              trackerId: this.trackingId,
            });
            if (paymentResult.ConfirmationNumber && paymentResult.ConfirmationNumber !== '') {
              this.confirmationNumber = paymentResult.ConfirmationNumber;
              this.paymentDate = new Date().toISOString();
              this.showFinal = true;
              this.showReview = false;
              this.showForm = false;

              dispatch('app/setIsLoading', false);
            } else {
              dispatch('app/setErrorMessage', paymentResult.Result);
              dispatch('app/setIsLoading', false);
            }
          })
          .catch((error) => {
            this.$store.dispatch('app/logToULS', {
              logLevel: 'Error',
              logMessage: error,
              fileName: 'NonLoggedInPremiumFinancePayment.vue',
              methodName: 'makePayment-Catch',
              trackerId: this.trackingId,
            });
            dispatch('app/setErrorMessage', error.toString());
            dispatch('app/setIsLoading', false);
          });
      },
      printConfirmation() {
        // TODO: Print confirmation
        window.print();
      },
    },
    watch: {
      'verifyForm.memberNumber'(val) {
        this.verifyForm.memberNumber = val.toUpperCase();
      },
    },
    mounted() {
      dispatch('app/clearErrorMessage');
      dispatch('app/setIsLoading', true);
      dispatch('app/doApplicationCheck', { sApplicationName: 'Payments', sTfbId: this.trackingId })
        .then((returnedStatus) => {
          if (returnedStatus === '') {
            if (this.queryPremiumFinance !== undefined && this.queryPremiumFinance !== null && this.queryPremiumFinance !== '') {
              // Premium Finance payment from Guidewire
              const decodedPremiumFinance = atob(this.queryPremiumFinance);
              const splitPremiumFinance = decodedPremiumFinance.split('/');
              this.memberNumber = splitPremiumFinance[0];
              this.contractNumber = splitPremiumFinance[1];
              this.currentPaymentAmount = splitPremiumFinance[2];

              this.memberRules.is = this.memberNumber;
              this.paymentForm.paymentAmount = this.currentPaymentAmount;
              this.amountDisabled = true;
            } else {
              dispatch('app/setErrorMessage', returnedStatus);
              dispatch('app/setIsLoading', false);
              this.formDisabled = true;
            }
          } else {
            dispatch('app/setErrorMessage', returnedStatus);
            dispatch('app/setIsLoading', false);
            this.formDisabled = true;
          }
          dispatch('app/setIsLoading', false);
        })
        .catch((error) => {
          dispatch('app/setErrorMessage', error.toString());
          dispatch('app/setIsLoading', false);
        });
    },
  };
</script>
<style lang="scss">

</style>
